<template>
  <view-container>
    <list-header
      :add="{
        name: 'user-new',
        params: { clientId: filter.clientId, partnerId: filter.partnerId }
      }"
    >
      <v-col cols="12" md="12" lg="4">
        <search-field v-model="filter.search" placeholder="Имя" />
      </v-col>
      <v-col cols="12" md="6" lg="4" v-if="showPartnerFilter">
        <reference-field
          label="Партнер"
          reference="partner"
          v-model="filter.partnerId"
        />
      </v-col>
      <v-col cols="12" md="6" lg="4" v-if="showClientFilter">
        <reference-field
          label="Клиент"
          reference="client"
          v-model="filter.clientId"
        />
      </v-col>
    </list-header>
    <v-card>
      <v-list one-line>
        <template v-for="(item, index) in items">
          <v-divider :key="index" v-if="index > 0" />
          <v-list-item
            :key="item.id"
            :to="{ name: 'user-edit', params: { id: item.id } }"
            :class="itemClass(item)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="item.name" />
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                v-if="item.partner"
                v-text="item.partner.name"
              />
              <v-list-item-action-text
                v-if="item.client"
                v-text="item.client.name"
              />
              <v-list-item-action-text v-else
                >Администратор</v-list-item-action-text
              >
            </v-list-item-action>
          </v-list-item>
        </template>
        <data-loader :watch="filter" :load="load" v-model="items" />
      </v-list>
    </v-card>
  </view-container>
</template>
<script>
import ds from "@/datastore";
export default {
  name: "UserList",
  props: ["id"],
  data() {
    return {
      items: [],
      filter: {
        search: ""
      },
      scope: null
    };
  },
  methods: {
    async load(pager) {
      let items = await ds.findAll("user", { ...pager, ...this.filter });
      if (this.showClientFilter) {
        items.forEach(item => item.loadRelations(["partner", "client"]));
      }
      return items;
    },
    itemClass(item) {
      return item.active ? "" : "inactive";
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
    showPartnerFilter() {
      return !this.scope && this.user.isAdmin;
    },
    showClientFilter() {
      return !this.scope && this.scope != "partner" && !this.user.clientId;
    }
  },
  created() {
    this.scope = this.$route.meta.scope;
    switch (this.scope) {
      case "client":
        this.filter.clientId = this.id;
        break;
      case "partner":
        this.filter.partnerId = this.id;
        break;
    }
    ds.on("afterCreate", (mapperName, props, opts, result) => {
      mapperName === "user" && this.items.unshift(result);
    });
  }
};
</script>
